// This component is not used anywhere. CH-8237
// @ts-expect-error TODO(typecheck-unify): TS6133 'React' is declared but its value is never read.
import React, { useState, Fragment } from "react";
import styled from "styled-components";

import { setMetropolitanStatisticalArea, setMetropolitanStatisticalAreaHCP } from "./api";
import { SelectMSA } from "./selectMSA";
import { showErrorToast } from "@src/appV2/lib/Notifications";

const Label = styled.label`
  margin-right: 10px;
`;

function SelectMetropolitanStatisticalArea({
  // @ts-expect-error TODO(typecheck-unify): TS7031 Binding element 'facilityId' implicitly has an 'any' type.
  facilityId,
  // @ts-expect-error TODO(typecheck-unify): TS7031 Binding element 'agentId' implicitly has an 'any' type.
  agentId,
  // @ts-expect-error TODO(typecheck-unify): TS7031 Binding element 'defaultMetropolitanStatisticalArea' implicitly has an 'any' type.
  defaultMetropolitanStatisticalArea,
}) {
  const [selectedMetropolitanStatisticalArea, setSelectedMetropolitanStatisticalArea] = useState(
    defaultMetropolitanStatisticalArea
  );

  // @ts-expect-error TODO(typecheck-unify): TS7006 Parameter 'newMetropolitanStatisticalArea' implicitly has an 'any' type.
  const onMetropolitanStatisticalAreaChange = async (newMetropolitanStatisticalArea) => {
    try {
      if (facilityId) {
        await setMetropolitanStatisticalArea(facilityId, newMetropolitanStatisticalArea);
      } else {
        await setMetropolitanStatisticalAreaHCP(agentId, newMetropolitanStatisticalArea);
      }

      setSelectedMetropolitanStatisticalArea(newMetropolitanStatisticalArea);
    } catch (err) {
      // eslint-disable-next-line no-console
      console.log(err);
      showErrorToast("The Metropolitan Statistical Area could not be changed. Please try again.");
    }
  };

  return (
    <Fragment>
      <Label>MSA</Label>
      <SelectMSA
        onChange={onMetropolitanStatisticalAreaChange}
        value={selectedMetropolitanStatisticalArea}
        disabled={false}
      ></SelectMSA>
    </Fragment>
  );
}

export default SelectMetropolitanStatisticalArea;
